import { TabPanels } from '@fiverr-private/navigation';

export default TabPanels;
